// Main.tsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import DukareeApp from "./DukareeApp";
import ProductionApp from "./ProductionApp";
import WarehouseApp from "./WarehouseApp";
import ERPApp from "./ERPApp";
import AIPOApp from "./AIPOProcessingApp";
import SysIntegration from "./SystemIntegrationApp";

export default function Main() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/dukaree" element={<DukareeApp />} />

        <Route path="/production" element={<ProductionApp />} />
        <Route path="/warehouse" element={<WarehouseApp />} />
        <Route path="/erp" element={<ERPApp />} />
        
        <Route path="/aipo" element={<AIPOApp />} />
        <Route path="/integration" element={<SysIntegration />} />

      </Routes>
    </Router>
  );
}
